import { useSyncExternalStore } from 'react';
import { ConnectionMonitor, type ConnectionStatus } from '@tradeoutlet/shared';

/**
 * t574u: the one connection monitor for this tab (packages/shared ConnectionMonitor). Fed by the realtime hub (socket
 * and channel health), every API response (lib/api.ts) and the browser's online/offline events; read by the sidebar's
 * Wi-Fi icon and the phone's offline banners.
 */
export const connection = new ConnectionMonitor({ deviceOnline: typeof navigator === 'undefined' || navigator.onLine !== false });

if (typeof window !== 'undefined') {
  window.addEventListener('online', () => connection.setDeviceOnline(true));
  window.addEventListener('offline', () => connection.setDeviceOnline(false));
}

const subscribe = (fn: () => void) => connection.subscribe(() => fn());

/** What the sidebar's connection icon shows: 'online', or 'reconnecting' / 'offline' once a problem has lasted. */
export function useConnectionStatus(): ConnectionStatus {
  return useSyncExternalStore(subscribe, connection.getStatus, () => 'online' as const);
}

/**
 * t574u: the device's online signal for the phone pages (offline banners, queue-or-send): the browser's
 * navigator.onLine, except that any API response since it said "offline" proves otherwise, so a false negative can't
 * leave the page stuck offline while everything works.
 */
export function useDeviceOnline(): boolean {
  return useSyncExternalStore(subscribe, () => connection.isDeviceOnline(), () => true);
}
